/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import moment from "moment";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

export const DATAZOOM_LOGO = "../images/datazoom.svg";
export const DZ_LOGO = "../images/dz.svg";
export const BILLING_ADMIN = "BILLING_ADMIN";
export const CUSTOMER_ADMIN = "CUSTOMER_ADMIN";
export const SUPER_ADMIN_ROLE = "SUPER_ADMIN";
export const USER_ROLE = "USER";
export const ADMIN_ROLE = "ADMIN";
export const COMPANY_ID = "a573aecc-03c6-472a-b2b9-4704ec9f3a92";
export const DATA_POINT_TYPE = ["Event", "FluxData", "Metadata"];
export const MEDIA_TYPES = ["ad", "content", "ad,content", "not_appl"];
export const UI_GROUPS = [
  "Message",
  "Events",
  "Attributes",
  "FluxData",
  "User Details",
  "Device",
  "Player",
  "Video",
  "Location",
  "Network",
  "CDN",
  "CMCD",
  "Page",
  "Ad",
  "Custom Data",
];
export const MESSAGE_NODE = [
  "event",
  "event.type",
  "event.attributes",
  "event.metrics",
  "root",
  "user_details",
  "player",
  "device",
  "video",
  "geo_location",
  "network",
  "page",
  "ad",
  "cdn",
  "cmcd",
  "custom",
  "ops_metadata",
];
export const DATA_TYPE = [
  { label: "Boolean", value: "boolean" },
  { label: "Number", value: "number" },
  { label: "String", value: "string" },
  { label: "Array of strings", value: "array of string" },
];
export const FIELD_TYPE = ["string", "bool", "number", "array of string"];
export const PERMITTED_VALUES = [
  "any",
  "comma separated list",
  "value list",
  "IP address",
  "URL",
  "UUID",
  // "UUID incremented",
  "2 letter code",
  // "3 letter code",
];
export const PII_HANDLING = [
  "None",
  //  "Drop",
  "Delete",
  "Anonymize",
  "Reduce Precision",
];
export const UNIT = [
  "percentage",
  "milliseconds",
  "seconds",
  "kbps",
  "pixels",
  "fps",
  "count",
  "bytes",
  "microseconds",
  "degrees",
  "hours",
];
export const NUMBER_TYPES = [
  { label: "Int", value: "int" },
  { label: "Short", value: "short" },
  { label: "Long", value: "long" },
  { label: "Float", value: "float" },
  { label: "Double", value: "double" },
  { label: "Not Set", value: "not_set" },
];

export const PRODUCTION = "prod";
export const DEVICE_PLATFORM = [
  "Browser",
  "Mobile",
  "DTV",
  "Server API",
  "Console",
];
export const DATA_POINT_LIST = [
  "Status",
  "Dictionary Version",
  "Data Point Type",
  "UI Group",
  "Message Node",
];
export const AUTHORED = true;
export const UNAUTHORED = false;
export const DATA_POINT_STATUS = ["Active", "Deprecated"];
export const DATA_POINT_SAVED = "Data Point Saved";
export const CREATE_JIRA_MSG = "Successfully mapped datapoint to collectors";
export const UPDATE_DATAPOINT_MANAGEMENT_MSG =
  "Successfully updated the status of collector datapoint mapping”";
export const DATA_POINT_ERROR_TITTLE = "Error Saving Data Point";
export const CREATE_CONNECTOR_ERROR_TITLE = "Error Saving Create Connector";
export const PROJECT_SAVED = "Project Saved";
export const PROJECT_ERROR_TITTLE = "Error Saving Project";
export const DATA_DICTIONARY = "Data Point Management";
export const SETTINGS = "Settings";
export const CREATE_DATA_POINTS = "create data point";
export const SEARCH_DATA_POINT = "Search Data Points";
export const PROJECTS = "Projects";
export const CREATE_PROJECT = "create project";
export const SEARCH_PROJECTS = "Search Projects";
export const COLLECTORS = "Collectors";
export const COLLECTOR = "Collector";
export const DATAPIPE = "Data Pipe";
export const CREATE_COLLECTOR = "create collector";
export const SEARCH_COLLECTORS = "Search Collectors";
export const VIEW_GRID = "grid";
export const VIEW_LIST = "list";
export const COL_IMG_URL = "/images/collectors-player/";
export const COL_PLATFORM_IMG_URL = "/images/platform-player/";
export const COL_GRAYOUT_IMG_URL = "/images/collectors-grayout-player/";
export const PLA_GRAYOUT_IMG_URL = "/images/platform-grayout-player/";
export const CONNECTORS = "Connectors";
export const DATAPIPES = "Data Pipes";
export const CREATE_DATAPIPE = "create Data Pipe";
export const SEARCH_DATAPIPE = "Search Data Pipes";
export const CONNECTOR = "Connector";
export const CREATE_CONNECTOR = "create connector";
export const SEARCH_CONNECTOR = "Search Connectors";
export const COLLECTOR_BLOCKED_NO = "y";
export const COLLECTOR_BLOCKED_YES = "n";
export const LINK_COLLECTOR_ERROR_TITTLE = "Error Saving Link Collector";
export const LINK_CONNECTOR_ERROR_TITTLE = "Error Saving Link Connector";
export const LINKED_PROJECT = "Linked to Project";
export const REMOVE_PROJECT = "Click to remove Project link";
export const LINK_PROJECT = "Link to Project";
export const UNASSIGNED_PROJECT = "Unassigned";
export const CUSTOM_DATA = "Custom Data";
export const SERACH_CUSTOM_DATA = "Search Custom Data";
export const CREATE_COMPANY = "Create Company";
export const SERACH_COMPANY = "Search Companies";
export const USER_SAVED = "User Saved";
export const USER_ERROR_TITTLE = "Error Saving User";
export const PASSWORD_RESET_ERROR = "Password Reset Error";
export const CREATE = "CREATE";
export const DELETE = "DELETE";
export const UPDATE = "UPDATE";
export const CREATE_DATAPOINT = "The data point was created.";
export const DELETE_DATAPOINT = "The data point was deleted.";
export const FIELD_CHANGES = "Changes were made to the following fields:";
export const NO_LOG_MESSAGE = "No log details available";
export const COLLECTOR_SUPPORT = "Collector Support";
export const CREATE_JIRA_TICKETS = "Create Jira Tickets";

export const sortItem = [
  {
    header: "Sort by",
    menuItems: [
      {
        name: "Last Modified",
        value: "lastModified",
      },
      {
        name: "Usage Amount",
        value: "usageMeterReading",
      },
      {
        name: "Collector",
        value: "playerName",
      },
      {
        name: "Configuration Name",
        value: "configName",
      },
    ],
  },
];

export const sortItemV2 = [
  {
    header: "Sort by",
    menuItems: [
      {
        name: "Name",
        value: "configName",
      },
      {
        name: "Last Modified",
        value: "lastModified",
      },
    ],
  },
];
export const sortConnectorItem = [
  {
    menuConnectorItems: [
      {
        name: "Last Modified",
        value: "lastModified",
      },
      {
        name: "Usage Amount",
        value: "usageMeterReading",
      },
      {
        name: "Connector",
        value: "connectorName",
      },
      {
        name: "Configuration Name",
        value: "configName",
      },
    ],
  },
];
export const sortDatapipeItem = [
  {
    menuDatapipeItems: [
      {
        name: "Last Modified",
        value: "updatedOn",
      },
      {
        name: "Name",
        value: "title",
      },
      {
        name: "Company",
        value: "companyName",
      },
    ],
  },
];
export const LINK_COLLECTOR_PROJECT = "Link Collector to Project";
export const LINK_CONNECTOR_PROJECT = "Link Connector to Project";
export const COLLECTOR_STATUS = ["Active", "Disabled"];
export const COLLECTOR_TYPE = ["CDN", "Player"];
export const COLLECTOR_DATA_SOURCE_TYPE = ["CDN", "App & Media Players"];
export const HEARTBEAT_INTERVAL = [
  { value: 1, label: "1 sec" },
  { value: 5, label: "5 sec" },
  { value: 10, label: "10 sec" },
  { value: 15, label: "15 sec" },
  { value: 30, label: "30 sec" },
  { value: 60, label: "60 sec" },
  { value: 300, label: "300 sec" },
];
export const HEARTBEAT_INTERVAL_LABEL = "Heartbeat Interval";
export const SAMPLING_RATE_LABEL = "Sampling Rate";
export const CONNECTOR_SAMPLING_LABEL = "Connector Sampling";
export const COLLECTOR_SAMPLING_RATE = [
  { value: 1, label: "1%" },
  { value: 10, label: "10%" },
  { value: 25, label: "25%" },
  { value: 50, label: "50%" },
  { value: 75, label: "75%" },
  { value: 100, label: "100%" },
];
export const CDN_REQUEST = "Include CMCD fields in CDN requests";
export const ENRICHMENT_LEVEL_LABEL = "Enrichment level";
export const ENRICHMENT_LEVEL = [
  { value: "LITE", label: "Datazoom Lite" },
  { value: "FULL", label: "Media Player" },
];
export const COLLECTOR_ACTIVE_STATUS =
  "Collector is currently enabled. Data Points selected in the Data Pipe for this Collector instance will be sent from user devices to Datazoom’s platform.";
export const COLLECTOR_DISABLED_STATUS =
  "Collector is currently disabled. Data will not be collected from any applications using this configuration. Don’t worry, the Collector can be re-activated at any time.";
export const ENABLE_COLLECTOR = "collector_sampling";
export const ENABLE_CONNECTOR = "connector_sampling";
export const ENABLE_CMCD = "cmcd";
export const COLLECTOR_SAVED = "Collector Saved";
export const COLLECTOR_ERROR_TITTLE = "Error Saving Collector";
export const COLLECTOR_PAUSED = "Data collection paused.";
export const COLLECTOR_DISABLED = "Collector is disabled";
export const COLLECTOR_ENABALED = "Collector is enabled";
export const CONNECTOR_DISABLED = "Connector is disabled";
export const CONNECTOR_ENABLED = "Connector is enabled";
export const CONNECTOR_DELETE_MESSAGE =
  "Connector configuration successfully deleted";
export const COLLECTOR_DELETE_MESSAGE =
  "Collector configuration successfully deleted";
export const UPDATE_MSG =
  "Update required to enable enhanced MediaTailor functionality.";
export const CONFIGURATION_ID_MSG =
  "Copy your Collector Configuration ID to use as part of the standard integrations of the Datazoom SDK or for analysis by collector.";
export const LATEST_VERSION_MSG =
  "Review Datazoom's integration options to always stay up to date. If you prefer to pin this Collector version in your project, you can copy a link to or download it here.";
export const COLLECTOR_COPY_CONFIG_MESSAGE =
  "Collection Key has been copied to your clipboard";
export const COPY_CONFIGURATION_ID =
  "Configuration ID has been copied to your clipboard";
export const COPY_CONFIGURATION_ID_DATAPIPE =
  "Configuration ID copied to your clipboard";
export const SDK_DOWNLOAD_MSG = "Collector build has been downloaded.";
export const SDK_URL_MSG =
  "URL to collector build has been copied to your clipboard.";
export const COMPANY_COPY_CONFIG_MESSAGE =
  "Company Code has been copied to your clipboard";
export const COLLECTOR_RESUMED = "Data collection resumed.";
export const COLLECTOR_NAME = "Collector name updated.";
export const CONNECTOR_ACTIVE_STATUS =
  "Connector is currently enabled. Data from Collectors joined with this Connector via Data Pipe will be delivered.";
export const CONNECTOR_DISABLED_STATUS =
  "Connector is currently disabled. Data will not be delivered to this Connector.  Don't worry; data delivery can be resumed at any time.";
export const EXEMPT_DESCRIPTION =
  "Data sent to this Connector will not be charged to the customer.";
export const DDV2_DESCRIPTION =
  "Data sent to this Connector will be converted to Data Dictionary v2 naming conventions.";
export const CONNECTOR_SAMPLING_RATE = [
  { value: 1, label: "1%" },
  { value: 5, label: "5%" },
  { value: 10, label: "10%" },
  { value: 25, label: "25%" },
  { value: 50, label: "50%" },
  { value: 100, label: "100%" },
];
export const ACCOUNT_SPECIFICATION = "Account Specifications";
export const DATA_FORMATING = "Data Formatting";
export const REDIRECT_STANDARD_FIELDS = "Redirect Standard Fields";
export const CONNECTOR_ACTIVE = "ACTIVE";
export const CONNECTOR_INACTIVE = "INACTIVE";
export const CONNECTOR_ERROR_TITTLE = "Error Saving Connector";
export const CONNECTOR_SAVED = "Connector Saved";
export const CONNECTOR_PAUSED = "Data connection paused.";
export const CONNECTOR_RESUMED = "Data connection resumed.";
export const CONNECTOR_EXEMPT = "Connector is now exempt.";
export const CONNECTOR_BILLABLE = "Connector is now billable.";
export const CONNECTOR_DDV2 = "Connector now uses DDV2.";
export const CONNECTOR_DDV3 = "Connector now uses DDV3.";
export const CONNECTOR_NAME = "Connector name updated.";
export const COLLECTOR_PAUSED_BUTTON = "Pause Data Collection";
export const COLLECTOR_RESUME_BUTTON = "Resume Data Collection";
export const CONNECTOR_PAUSED_BUTTON = "Pause Data Connection";
export const CONNECTOR_RESUME_BUTTON = "Resume Data Connection";
export const EXEMPT_UNCHECK = "Make Exempt";
export const EXEMPT_CHECK = "Make Billable";
export const DDV2_UNCHECK = "Convert to DDV2";
export const DDV2_CHECK = "Promote to DDV3";
export const EXEMPT = "Exempt";
export const DDV2 = "DDV2";
export const CONNECTOR_CONTROL = "Connector Control";
export const DISABLE_MEASUREMENT_BUTTON = "DISABLE OPEN MEASUREMENT";
export const ENABLE_MEASUREMENT_BUTTON = "ENABLE OPEN MEASUREMENT";

export const DZ_MOCK_CONNECTOR = "dz-connector-mock";
export const DZ_AMPLITUDE_CONNECTOR = "dz-connector-amplitude";
export const DZ_TV_INSIGHT_MOCK = "dz-connector-tvinsight-mock";
export const DZ_TV_INSIGHT = "dz-connector-tvinsight";
export const DZ_AZURE = "dz-connector-azure-blob-storage";
export const DZ_DATADOG = "dz-connector-datadog";
export const DZ_SPLUNK_CONNECTOR = "dz-connector-splunk";
export const DZ_GOOGLE_ANALYTICS = "dz-connector-google-analytics";
export const DZ_GOOGLE_ANALYTICS_V4 = "dz-connector-google-analytics-4";
export const DZ_GOOGLE_CLOUD_STORAGE = "dz-connector-gcs";
export const DZ_GOOGLE_BIG_QUERY_CONNECTOR = "dz-connector-bigquery";
export const DZ_NEW_RELIC = "dz-connector-newrelic";
export const DZ_OTAVA = "dz-connector-otava";
export const DZ_KINESIS_FIREHOSE = "dz-connector-kinesis-firehose";
export const DZ_KINESIS_DATASTREAMS = "dz-connector-amazon-kinesis-datastreams";
export const DZ_AMAZON_S3 = "dz-connector-s3";
export const DZ_HYDROLIX_CONNECTOR = "dz-connector-hydrolix";
export const DZ_COMSCORE = "dz-connector-comscore";
export const DZ_SIGNAL_FX = "dz-connector-signalfx";
export const DZ_SPLUNK_MOCK = "dz-connector-splunk-mock";
export const DZ_WATCHING_THAT = "dz-connector-watching-that";
export const DZ_TRAFFIC_PEAK = "dz-connector-trafficpeak";
export const DZ_CASCADE_CONNECTOR = "dz-connector-cascade";
export const DZ_AMAZON_S3_QA = "dz-connector-s3-qa";
export const DZ_DATA_MINER = "dz-connector-dataminer";
export const DZ_CORALOGIX = "dz-connector-coralogix";

export const ACCESS_CONTROL = "Access Control";
export const VALIDATION_ERROR_MESSAGE =
  " The information entered resulted in a verification error. Please confirm the details before saving this Connector.";

export const OUTPUT_FORMAT = "Output Format";
export const REGION = "Region";
export const SEVERITY = "Severity";
export const WARNING_MESSAGE =
  "You have made some data changes on this page. If you navigate away from this page without first saving your data, the changes will be lost.";
export const MEDIATAILOR_SETTINGS_MSG =
  "Open Measurement viewability and verification measurement for streaming video ads";
export const CONNECTOR_REGION = [
  { value: "US1", label: "US1" },
  { value: "US3", label: "US3" },
  { value: "US5", label: "US5" },
  { value: "EU1", label: "EU1" },
  { value: "US1-FED", label: "US1-FED" },
];
export const STEP_COLLECTOR = [
  {
    label: "Select Data Source",
    description: "Select the source of the data to be collected",
  },
  {
    label: "Name Configuration",
    description:
      "Give this Collector instance a unique name so you can identify it throughout the Datazoom application",
  },
  {
    label: "Deploy Collector",
    description:
      "Start using this Collector today by configuring it with your application",
  },
];

export const STEP_CONNECTOR = [
  {
    label: "Select Destination",
    description: "Select the location to deliver data",
  },
  {
    label: "Name Configuration",
    description:
      "Give this Connector instance a unique name so you can identify it throughout the Datazoom application",
  },
  {
    label: "Access Control",
    description:
      "Provide Datazoom with necessary privileges to write data to your account",
  },
  {
    label: "Deploy Connector",
    description: "Associate this Connector with a Data Pipe",
  },
];

export const COLLECTOR_CATAGORY_TVOS = "tvOS";
export const COLLECTOR_CATAGORY_OTT = "OTT";
export const COLLECTOR_CATAGORY_CDN = "CDN";
export const COLLECTOR_TYPE_PLAYER = "PLAYER";
export const VIDEO_PLAYER = "App & Media Players";
export const PLAYER = "PLAYER";
export const CDNS = "CDNs";
export const JAVASCRIPT = "Javascript";
export const OTT_DEVICES = "OTT Devices";
export const SERVER_TO_SERVER = "Server to Server";
export const NEW_RELIC_CONNECTOR_REGION = [
  { value: "US", label: "US" },
  { value: "EU", label: "EU" },
];
export const VALIDTYPES = [
  "Omit from UI",
  "Deprecated",
  "Required",
  "For MediaPlayer",
];
export const USE_VIDEO_DATA_MONITORING_MODEL =
  "Use Video Monitoring Data Model";
export const CONNECTOR_AWS_REGION = [
  { value: "us-east-1", label: "us-east-1" },
  { value: "us-east-2", label: "us-east-2" },
  { value: "us-west-1", label: "us-west-1" },
  { value: "us-west-2", label: "us-west-2" },
  { value: "af-south-1", label: "af-south-1" },
  { value: "ap-east-1", label: "ap-east-1" },
  { value: "ap-south-1", label: "ap-south-1" },
  { value: "ap-south-2", label: "ap-south-2" },
  { value: "ap-southeast-1", label: "ap-southeast-1" },
  { value: "ap-southeast-2", label: "ap-southeast-2" },
  { value: "ap-southeast-3", label: "ap-southeast-3" },
  { value: "ap-southeast-4", label: "ap-southeast-4" },
  { value: "ap-northeast-1", label: "ap-northeast-1" },
  { value: "ap-northeast-2", label: "ap-northeast-2" },
  { value: "ap-northeast-3", label: "ap-northeast-3" },
  { value: "ca-central-1", label: "ca-central-1" },
  { value: "cn-northwest-1", label: "cn-northwest-1" },
  { value: "eu-central-1", label: "eu-central-1" },
  { value: "eu-west-1", label: "eu-west-1" },
  { value: "eu-west-2", label: "eu-west-2" },
  { value: "eu-west-3", label: "eu-west-3" },
  { value: "eu-south-1", label: "eu-south-1" },
  { value: "eu-south-2", label: "eu-south-2" },
  { value: "eu-north-1", label: "eu-north-1" },
  { value: "eu-central-2", label: "eu-central-2" },
  { value: "me-south-1", label: "me-south-1" },
  { value: "me-central-1", label: "me-central-1" },
  { value: "sa-east-1", label: "sa-east-1" },
  { value: "gov-east-1", label: "gov-east-1" },
  { value: "us-gov-west-1", label: "us-gov-west-1" },
];
export const CORALOGIX_ENDPOINTS = [
  { value: "coralogix.us", label: "coralogix.us" },
  { value: "cx498.coralogix.com", label: "cx498.coralogix.com" },
  { value: "coralogix.com", label: "coralogix.com" },
  { value: "eu2.coralogix.com", label: "eu2.coralogix.com" },
  { value: "coralogix.in", label: "coralogix.in" },
  { value: "coralogixsg.com", label: "coralogixsg.com" },
  { value: "ap3.coralogix.com", label: "ap3.coralogix.com" },
];

export const AD_FRAMEWORK_DROPDOWN = [
  { value: "None", label: "None" },
  { value: "MediaTailor", label: "MediaTailor" },
  { value: "Player Default", label: "Player Default" },
  { value: "Freewheel", label: "Freewheel" },
  { value: "Google Ima", label: "Google IMA" },
  { value: "Google Ima Dai", label: "Google IMA DAI" },
  { value: "Yospace", label: "Yospace" },
];

export const COLLECTOR_DOCUMENTATION =
  "This Collection Key is used to tie an application to this specific Collector instance. Copy the key today to insert it into an integration. This key can be found at anytime on the Collector Settings page.";
export const COLLECTOR_CONFIGURATION_TEXT =
  "This Collector Configuration ID is used to tie an application to this specific Collector instance. Copy the key today to insert it into an integration. This key can be found at anytime on the Collector Settings page.";
export const COLLECTOR_CDN_TEXT =
  "This API Key is used to tie a log stream to this specific Collector instance. Copy the key today to insert it into an integration.  This key can be found at anytime on the Collector Settings page.";
export const CONNECTOR_TO_DATAPIPE_TEXT =
  "By adding this Connector to an existing data pipe, data can start being delivered immediately or create a new data pipe with specific Collectors and Data Points targeted to this Connector configuration.";
export const COLLECTOR_DEPLOY_TEXT =
  "Get started collecting data right away. The information below will help complete the integration of this Collector with the application or data source to be monitored.";
export const CONNECTOR_DEPLOY_TEXT =
  "Get started transmitting data right away.  The information below will help complete the pairing of this Connector with a Collector data source.";
export const COLLECTOR_CONFIG_SETTINGS_TEXT =
  "View all of the Collector configuration settings which can be used to tune the Collector by setting desired preferences.";
export const CONNECTOR_CONFIG_SETTINGS_TEXT =
  "View all of the Connector configuration settings which can be used to tune the Connector by setting desired preferences.";
export const API_KEY_MESSAGE = "API Key has been copied to your clipboard";
export const API_ACCESS_CDN_TEXT =
  "Any service using this API Key can submit logs for Datazoom processing. Regenerate a new key if needed due to security concerns.";
export const API_GENERATE_CDN_TEXT =
  "Regenerate API Key will invalidate the existing API and not allow new log collection, breaking any existing integration. Please confirm that this is understood.";
export const CONNECTOR_BUIK_OUTPUT_FORMAT = "Bulk_Output_Format";
export const CONNECTOR_JSON_ARRAY = "JSON_ARRAY";
export const CONNECTOR_OBJECT_NAME_STRUCTURE = "Object_Name_Structure";
export const CONNECTOR_REDIRECT_STANDARD_FIELDS = "Redirect_Standard_Fields";
export const CONNECTOR_CUSTOM_DIMENSION_METRIC =
  "Custom_Dimension-Metric_Index_Mapping";
export const CONNECTOR_DATA_MONITORING_MODAL =
  "Use_Video_Data_Monitoring_Model";
export const CONNECTOR_SERVICE_ACCOUNT_JSON = "Service_Account_JSON";
export const CONNECTOR_CUSTOMER_MAP = "Customer_Map";
export const CONNECTOR_OBJECT_NAME = "Object_Name";
export const API_KEY_GENERATE_SUCCESS_RESPONSE =
  "Successfully regenerated the collector API Key.";
export const EVENT_TYPE = "Event_Type";

export const NEVER = "NEVER";
export const IN_THE_PAST = "IN THE PAST";
export const TODAY = "TODAY";
export const INACTIVITY_INTERVAL_LABEL = "Inactivity interval";
export const INACTIVITY_INTERVAL = [
  { value: -1, label: "None" },
  { value: 1, label: "1 mins" },
  { value: 5, label: "5 mins" },
  { value: 15, label: "15 mins" },
  { value: 20, label: "20 mins" },
  { value: 30, label: "30 mins" },
  { value: 60, label: "60 mins" },
  { value: 120, label: "120 mins" },
  { value: 240, label: "240 mins" },
  { value: 480, label: "480 mins" },
  { value: 960, label: "960 mins" },
  { value: 1440, label: "1440 mins" },
];
export const ERROR_MSG_INACTIVITY_INTERVAL =
  "Must be greater than or equal to your heartbeat interval";
export const COLLECTOR_INTEGRATE_TEXT =
  "Integrate this Collector into your application";
export const COLLECTOR_NO_DATA_TEXT =
  "No data received from this Collector recently, verify your integration";
export const COLLECTING_DATA = "Collecting Data";
export const COLLECTION_INTERRUPTED = "Collection Interrupted";
export const ADD_TO_APPLICATION = "Add to Application";
export const ATTACH_THIS_COLLECTOR =
  "Attach this Collector to a Data Pipe to start collection";
export const COLLECTOR_ARE_PAUSED =
  "All Data Pipes with this Collector are paused";
export const DATAPIPE_CONFIGURED = "Data Pipe Configured";
export const DATAPIPE_PAUSED = "Data Pipe Paused";
export const ADD_TO_DATAPIPE = "Add to Data Pipe";
export const RE_ENABLE_THIS_COLLECTOR =
  "Re-enable this Collector to begin data collection";
export const COLLECTOR_STATUS_ACTIVE = "Collector Active";
export const COLLECTOR_STATUS_PAUSED = "Collector Paused";
export const CONNECTOR_STATUS_ACTIVE = "Connector Active";
export const CONNECTOR_STATUS_PAUSED = "Connector Paused";
export const RE_ENABLE_THIS_CONNECTOR =
  "Re-enable this Connector to begin data delivery";
export const CONNECTOR_ARE_PAUSED =
  "All Data Pipes with this Connector are paused";
export const ATTACH_THIS_CONNECTOR =
  "Attach this Connector to a Data Pipe to start delivery";
export const DELIVERING_DATA = "Delivering Data";
export const CONNECTION_INTERRUPTED = "Connection Interrupted";
export const NO_DATA_DELIVERED = "No Data Delivered";
export const CONNECTOR_NO_DATA_TEXT =
  "No data delivered to this Connector recently, verify your settings";
export const CONNECTOR_ACCOUNT_DETAILS_TEXT =
  "Verify the account details for this Connector";
export const ProjectTabs = [
  {
    label: "Stats",
    value: 0,
  },
  {
    label: "Collectors",
    value: 1,
  },
  {
    label: "Connectors",
    value: 2,
  },
  {
    label: "Historical Usage",
    value: 3,
  },
];
export const CUSTOM_DATA_DETAIL_DESCRIPTION =
  "Unique identifier for the user. Should use subscription ID if available, if not leave null for anonymous user.";
export const PROJECT_USAGE_CHART = "CollectorConnectorUsage";
export const COMPANY_ACCOUNT_TYPE = [
  {
    name: "Trial",
    value: "TRIAL",
  },
  {
    name: "Pay-as-you-go",
    value: "STANDARD",
  },
  {
    name: "Contract",
    value: "CONTRACT",
  },
  ...(process.env.REACT_APP_MEDIA_TAILOR === "true"
    ? [
        { name: "MediaTailor Only", value: "MEDIATAILOR_ONLY" },
        { name: "MediaTailor Custom", value: "MEDIATAILOR_CUSTOM" },
      ]
    : []),
];

export const AD_FRAMEWORK_DESCRIPTION =
  "Supported data points from the selected ad framework will be available to be enabled.";
export const COMPANY_ACTIVE_RESPONSE =
  "Company is currently enabled. Collectors for this company will collect data and transmit to the configured Connectors.";
export const COMPANY_DISABLED_RESPONSE =
  "Company is currently disabled. Data flow for all of the Company's Collectors and Connectors is halted";
export const COMPANY_DISABLED_BUTTON = "Disable Company";
export const COMPANY_REENABLED_BUTTON = "RE-ENABLE COMPANY";
export const COMPANY_ACCOUNT_STATUS = [
  {
    name: "Active",
    value: "ACTIVE",
  },
  {
    name: "Disabled",
    value: "DISABLED",
  },
  {
    name: "Trial",
    value: "TRIAL",
  },
];
export const COMPANYT_EXCLUDED_FROM_UI = ["Hidden", "Visible"];
export const USERS = "Users";
export const SERACH_USER = "Search Users";
export const USER_ROLES_LIST = [
  "BILLING_ADMIN",
  "CUSTOMER_ADMIN",
  "SUPER_ADMIN",
  "USER",
  "ADMIN",
];
export const USER_STATUS = [
  { name: "Active", value: "Active" },
  { name: "Disabled", value: "Disabled" },
  { name: "Invited", value: "Invited" },
  { name: "Pending Approval", value: "Pending" },
];

export const DATAPIPE_STATUS = [
  { name: "Active", value: 0 },
  { name: "Disabled", value: 1 },
];

export const USER_DELETE_BUTTON = ["Cancel", "Delete User"];
export const TODAY_DATE_FORMAT = moment();
// .format("YYYY-MM-DD");
export const LAST_7_DAY_DATE_FORMAT = moment().subtract(6, "days");
// .format("YYYY-MM-DD");
export const MONTH_TO_DATE_FORMAT = moment().startOf("month");
// .format("YYYY-MM-DD");
export const LAST_30_DAYS_DATE_FORMAT = moment().subtract(29, "days");
// .format("YYYY-MM-DD");
export const LAST_MONTH_START_DATE_FORMAT = moment()
  .subtract(1, "months")
  .startOf("month");
// .format("YYYY-MM-DD");
export const LAST_MONTH_END_DATE_FORMAT = moment()
  .subtract(1, "months")
  .endOf("month");
// .format("YYYY-MM-DD");
export const YEAR_TO_DATE_FORMAT = moment().startOf("years");
// .format("YYYY-MM-DD");

export const DAYS_UP_TO_TODAY = "days up to today";
export const CONNECTOR_OUTPUT_FORMAT = [
  {
    label: "JSON Array",
    value: "JSON_ARRAY",
  },
  { label: "JSON Line", value: "JSON_LINE" },
];
export const VALIDATION_ERROR = "Validation error";
export const ADVERTISING_SETTINGS = "Advertising Settings";
export const MEDIATAILOR_SETTINGS = "MediaTailor Settings";
export const FLOAT = "float";
export const DOUBLE = "double";
export const DATA_DICTIONARY_NAME = "data-dictionary";
export const PlatformTabs = [
  {
    label: "Standard Rates",
    value: 0,
  },
  {
    label: "Custom Rates",
    value: 1,
  },
];
export const DELETE_STANDARD_RATE_MSG = "Standard Rate successfully deleted.";
export const UPCOMING_STATUS = "UPCOMING";
export const CURRENT_STATUS = "CURRENT";
export const RATE_CARD_ERROR_TITTLE = "Error Saving Rate Card";
export const OK_BUTTON = ["OK"];
export const TIER_MAX_HIGHER_THAN_MIN =
  "A tier's max must be higher than its min";
export const LEAVE_IT_BLANK =
  "The last tier must not have tier maximum. Leave it blank.";
export const NEW_STANDARD_RATE = "New Standard Rate Card";
export const NEW_CUSTOM_RATE = "New Custom Rate Card";
export const PAYMENT_TYPES = [
  { label: "Monthly", value: "monthly" },
  { label: "Upfront", value: "upfront" },
];
export const CREATE_JIRA_TICKET_BTN = ["Create Jira Tickets", "Cancel"];
export const STANDARD_ENRICHMENT_PRICING = "Use standard enrichment pricing";
export const DELETE_CUSTOM_RATE_MSG = "Custom Rate successfully deleted.";
export const COMPANY_STATUS = "Disabled";
export const TAB_ONE = "1";
export const TAB_TWO = "2";
export const TAB_THREE = "3";
export const TAB_FOUR = "4";
export const TAB_FIVE = "5";
export const BillingUsageList = [
  { label: "Usage", view: TAB_ONE },
  { label: "Billing Credits", view: TAB_TWO },
  { label: "Pricing", view: TAB_THREE },
  { label: "Invoice History", view: TAB_FOUR },
  { label: "Payment Method", view: TAB_FIVE },
];
export const MEDIATAILOR_ONLY = "MEDIATAILOR_ONLY";
export const MEDIATAILOR_CUSTOM = "MEDIATAILOR_CUSTOM";
export const DATAPIPE_HIDE_SUCCESS = "Data pipe is hidden from the customer";
export const DATAPIPE_UNHIDE_SUCCESS =
  "Data pipe is now visible to the customer";
export const DATAPIPE_HIDE_FAILED_TITTLE = "Error Saving Datapipe";
export const closeSvgIcon =
  "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z";
export const CDNCollectors = [
  "Akamai CDN",
  "Fastly CDN",
  "Lumen",
  "Amazon CloudFront",
];
export const COLLECTOR_MANAGEMENT = "Collector Management";
export const ADD_COLLECTOR = "Add Collector";
export const ADD_CUSTOM_DATA = "ADD DATA POINT";
export const COLLECTOR_MGMNT_LOG_TITLE = "Change History";
export const COLLECTOR_MANAGEMENT_LIST = {
  application: [
    {
      applicationId: "application1",
      applicationName: "Android",
      applicationKey: "android",
      currentVersion: "3.4.14",
      supportSampling: true,
      supportAppSessionTimeOut: true,
      jiraIntegrationStatus: true,
      status: true,
      mediaPlayers: [
        {
          collectorKey: "gen-2_exo_player",
          collectorName: "Gen-2 - Exo Player",
          id: "Mediapalyer-3",
          status: true,
          supportCmcd: false,
          supportSampling: true,
          supportAppSessionTimeOut: false,
          jiraIntegrationStatus: false,
          mediaPlayer: true,
        },
        {
          collectorKey: "media3_player",
          collectorName: "Media3 Player",
          id: "Mediapalyer-4",
          status: true,
          supportCmcd: false,
          supportSampling: true,
          supportAppSessionTimeOut: false,
          jiraIntegrationStatus: true,
          mediaPlayer: true,
        },
      ],
      adFrameworks: [
        {
          key: "mediaTailor",
          name: "MediaTailor",
          id: "adFrameworks-5",
          status: true,
          jiraTicketsCreated: true,
        },
        {
          key: "yospace",
          name: "Yospace",
          id: "adFrameworks-6",
          status: true,
          jiraTicketsCreated: false,
        },
      ],
    },
    {
      applicationId: "application2",
      applicationName: "Roku",
      applicationKey: "roku",
      supportSampling: true,
      supportAppSessionTimeOut: true,
      jiraIntegrationStatus: false,
      currentVersion: "2.4.14",
      status: false,
      mediaPlayers: [
        {
          collectorKey: "android_native_player",
          collectorName: "Android Native Player",
          id: "Mediapalyer-1",
          status: true,
          supportCmcd: false,
          supportSampling: true,
          supportAppSessionTimeOut: false,
          jiraIntegrationStatus: true,
          mediaPlayer: true,
        },
        {
          collectorKey: "gen-1-exo_player",
          collectorName: "Gen-1 - Exo Player",
          id: "Mediapalyer-2",
          status: false,
          supportCmcd: false,
          supportSampling: true,
          supportAppSessionTimeOut: false,
          jiraIntegrationStatus: false,
          mediaPlayer: true,
        },
      ],
      adFrameworks: [
        {
          key: "bitmovin_native_ad_frameworks",
          name: "Bitmovin Native Ad Frameworks",
          id: "adFrameworks-1",
          status: true,
          jiraTicketsCreated: true,
        },
        {
          key: "freewheel",
          name: "Freewheel",
          id: "adFrameworks-2",
          status: false,
          jiraTicketsCreated: false,
        },
      ],
    },
  ],
  api: [
    {
      collectorKey: "akamai",
      collectorName: "Akamai",
      id: "apiList-1",
      status: true,
      mediaPlayer: false,
      currentVersion: null,
      jiraTicketsCreated: false,
    },
    {
      collectorKey: "amazon_cloudfront",
      collectorName: "Amazon CloudFront",
      id: "apiList-2",
      status: false,
      currentVersion: "1.0.2",
      jiraTicketsCreated: true,
    },
    {
      collectorKey: "fastly",
      collectorName: "Fastly",
      id: "apiList-3",
      status: true,
      currentVersion: "2.0.0",
      jiraTicketsCreated: true,
    },
    {
      collectorKey: "lumen",
      collectorName: "Lumen",
      id: "apiList-4",
      status: true,
      currentVersion: "3.0.3",
      jiraTicketsCreated: true,
    },
  ],
};
export const APPLICATION_TYPE = "application";
export const MEDIAPLAYER_TYPE = "mediaPlayer";
export const AD_FRAMEWORK_TYPE = "adFramework";
export const API_TYPE = "api";
export const MEDIA_PLAYERS = "Media Players";
export const MEDIA_PLAYER = "Media Player";
export const MEDIA_PLAYER_EXTNS = "Media Player Extensions";
export const AD_FRAMEWORK = "Ad Framework";
export const AD_FRAMEWORKS = "Ad Frameworks";
export const AD_FRAMEWORK_EXTNS = "Ad Framework Extensions";
export const APPLICATION = "Application";
export const API = "API";
export const COLLECTOR_ACTIVE_MSG =
  "Disabling the collector will remove it from existing data pipes and from the list of possible collectors to configure.";
export const APP_COLLECTOR_ACTIVE_MSG =
  "Disabling the collector will remove it from the list of possible collectors to configure and disable associated collector configurations that are not attached to a data pipe. No impact to associated collector configurations that are currently attached to a data pipe.";
export const COLLECTOR_INACTIVE_MSG =
  "Enabling the collector makes it available in the list of possible collectors to configure.";
export const COLLECTOR_ENABLED_BUTTON = "disable collector";
export const COLLECTOR_DISABLED_BUTTON = "enable collector";
export const COLLECTOR_SAMPLING_ACTIVE_MSG =
  "If sampling support is disabled, existing sampling stops and the customer collector configuration settings to adjust sampling aren’t visible.";
export const COLLECTOR_SAMPLING_INACTIVE_MSG =
  "If sampling support is enabled, the customer collector configuration settings to adjust sampling will be visible.";
export const COLLECTOR_APP_SESSION_TIMEOUT_ACTIVE_MSG =
  "If configurable app session timeout duration is disabled, app sessions will timeout after 20 minutes of activity.";
export const COLLECTOR_APP_SESSION_TIMEOUT_INACTIVE_MSG =
  "If configurable app session timeout duration support is enabled, the customer collector configuration setting to configure app session timeout duration will be visible.";
export const COLLECTOR_JIRA_TICKET_FOR_APPLICATION_MSG =
  "Generate Jira tickets for each data point in the Application Data Dictionary.";
export const COLLECTOR_JIRA_TICKET_FOR_API_MSG =
  "Generate Jira tickets for each data point in the CDN Data Dictionary.";
export const COLLECTOR_JIRA_TICKET_FOR_AD_FRAMEWORK_MSG =
  "Generate Jira tickets for each data point in the Ad Framework Data Dictionary.";
export const API_JIRA_TICKET_MSG =
  "Separate Jira tickets will be created for data points in the CDN Data Dictionary.";
export const APPLICATION_JIRA_TICKET_MSG =
  "Separate Jira tickets will be created for data points in the Application Data Dictionary.";
export const COLLECTOR_JIRA_TICKET_FOR_MEDIA_PLAYER_MSG =
  "Generate Jira tickets for each data point in the Media Player Data Dictionary.";
export const COLLECTOR_ERROR_MGMT = "Error Collector Management";
export const MEDIA_PLAYER_JIRA_TICKET_MSG =
  "Separate Jira tickets will be created for data points in the Media Player Data Dictionary.";
export const AD_FRAMEWORK_JIRA_TICKET_MSG =
  "Separate Jira tickets will be created for data points in the Ad Framework Data Dictionary.";
export const COLLECTOR_CMCD_ACTIVE_MSG =
  "If CMCD support is disabled: CMCD data points won’t appear in the data point selector for collector configurations with this media player in data pipes and the customer collector configuration settings to include CMCD fields in CDN requests won’t be visible.";
export const COLLECTOR_CMCD_INACTIVE_MSG =
  "If CMCD support is enabled: CMCD data points will appear in the data point selector for collector configurations with this media player in data pipes and the customer collector configuration settings to include CMCD fields in CDN requests will be visible.";
export const CREATE_ALIAS_MSG =
  "Create a new alias for this data point so that it can be selected / unselected for collection on data pipes.";
export const SOURCE_COLLECTORS_MSG =
  "Source collectors represent the Datazoom collector configurations from which this unmapped key has been observed.";
export const ALIAS_NAME_MSG =
  "The alias name is how a custom data point is presented in the Datazoom console.";
export const MASTER_KEY_MSG =
  "The master key is how a custom data point is represented when it is delivered to your connectors unless you choose to prefer to use the original data point key";
export const MAP_TO_ALIAS_MSG =
  "Synonymous data points can be mapped to an existing alias to keep data points standardized. ";
("Create a new alias for this data point so that it can be selected / unselected for collection on data pipes.");
export const NO_SUPPORTED_MEDIAPLAYERS = "No Supported Media Players";
export const NO_SUPPORTED_ADFRAMEWORKS = "No Supported AdFrameworks";
export const DatapipeTabs = [
  {
    label: "Pipe Map",
    value: 0,
  },
  {
    label: "Data Points",
    value: 1,
  },
];
export const APPLICATION_DATA_DICTIONARY_V4 = "Application Data Dictionary v4";
export const APPLICATION_DATA_DICTIONARY_V2 = "Application Data Dictionary v2";
export const MEDIA_PLAYER_DATA_DICTIONARY_V1 =
  "Media Player Data Dictionary v1";
export const AD_FRAMEWORK_DATA_DICTIONARY_V1 =
  "Ad Framework Data Dictionary v1";
export const CDN_V3 = "CDN v.3";
export const DISABLE_MEDIA_PLAYER = "disable media player";
export const ENABLE_MEDIA_PLAYER = "enable media player";
export const DISABLE_AD_FRAMEWORK = "disable ad framework";
export const ENABLE_AD_FRAMEWORK = "enable ad framework";
export const VIDEO_PLAYER_V3 = "Video Player v.3";
export const VIDEO_PLAYER_V2 = "Video Player v.2";
export const DATAPIPE_CONFIG_MENU_LIST = [
  {
    id: "Copy configuration ID",
    name: "Copy configuration ID",
    icon: <ContentCopyIcon sx={{ fontSize: "1.3rem" }} />,
  },
  {
    id: "View data point exceptions",
    name: "View data point exceptions",
    icon: <ErrorOutlineOutlinedIcon sx={{ fontSize: "1.4rem" }} />,
  },
  {
    id: "Visit configuration details",
    name: "Visit configuration details",
    icon: <OpenInNewOutlinedIcon sx={{ fontSize: "1.3rem" }} />,
  },
  {
    id: "Remove configuration from pipe",
    name: "Remove configuration from pipe",
    icon: <HighlightOffOutlinedIcon sx={{ fontSize: "1.4rem" }} />,
  },
];

export const SORT_CHIP = [
  {
    label: "Recents",
    value: "lastModified",
  },
  {
    label: "A-Z",
    value: "1",
  },
];
export const DOMAIN = "Domain";

export const sourceCollectorTitles = [
  {
    key: "collectorConfiguration",
    label: "COLLECTOR CONFIGURATION",
    width: "40%",
  },
  {
    key: "collector",
    label: "COLLECTOR",
    width: "35%",
  },
  {
    key: "lastObserved",
    label: "LAST OBSERVED",
    width: "25%",
  },
];
export const mappedKeyTitles = [
  {
    key: "key",
    label: "KEY",
    width: "30%",
  },
  {
    key: "collector",
    label: "COLLECTOR",
    width: "28%",
  },
  {
    key: "scope",
    label: "SCOPE",
    width: "17%",
  },
  {
    key: "lastObserved",
    label: "LAST OBSERVED",
    width: "17%",
  },
];
export const CUSTOM_DATA_TYPE = ["Alias", "Unmapped Key"];
export const CUSTOM_DATA_POINT_TYPE = ["Event", "Metadata"];

export const STRING = [
  { label: "Any", value: "any" },
  { label: "Value List", value: "value list" },
  { label: "IP Address", value: "ip address" },
  { label: "URL", value: "url" },
  { label: "UUID", value: "uuid" },
  { label: "Two Letter Code", value: "two letter code" },
];

export const NUMBER_TYPES_CUSTOM = [
  { label: "Short", value: "short" },
  { label: "Int", value: "int" },
  { label: "Long", value: "long" },
  { label: "Float", value: "float" },
  { label: "Double", value: "double" },
];

export const DECIMELS_CUSTOM = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const UNIT_CUSTOM = [
  { label: "Count", value: "count" },
  { label: "Microseconds", value: "microseconds" },
  { label: "Milliseconds", value: "milliseconds" },
  { label: "Seconds", value: "seconds" },
  { label: "Hours", value: "hours" },
  { label: "Percentage", value: "percentage" },
  { label: "Bytes", value: "bytes" },
  { label: "KBPS", value: "kbps" },
  { label: "Pixels", value: "pixels" },
  { label: "Degrees", value: "degrees" },
  { label: "FPS", value: "fps" },
];

export const ENRICHMENT_LEVEL_TOOLTIPS = {
  FULL: "The Media Player enrichment level makes all of the CMCD dimensions supported for the media player collectable.",
  LITE: "The Datazoom Lite enrichment level makes only the Request ID and Session ID needed for stack tracing collectable.",
};
